/**
 * Logs an info message with timestamp
 */
export const logInfo = (...args) => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] INFO:`, ...args);
};

/**
 * Logs an error message with timestamp
 */
export const logError = (...args) => {
  const timestamp = new Date().toISOString();
  console.error(`[${timestamp}] ERROR:`, ...args);
};

/**
 * Logs the configuration, excluding sensitive fields
 */
export const logConfig = (config) => {
  // Create a copy of the config object
  const safeConfig = { ...config };
  
  // Remove sensitive fields
  if (safeConfig.api_bearer) {
    safeConfig.api_bearer = '[REDACTED]';
  }
  
  if (safeConfig.discord?.client_secret) {
    safeConfig.discord.client_secret = '[REDACTED]';
  }
  
  logInfo('Configuration:', safeConfig);
};